import { integrationsAlierSGAPurchaseOutboxQueueAdminService } from '@/services';

export const integrationsAlierSGAPurchaseOutboxQueueAdminModule = {
  namespaced: true,
  state: () => ({
    list: {
      data: null,
      response: null,
      status: 'idle'
    },
    listFilters: {},
  }),
  mutations: {
    setListError(state, response) {
      state.list.data = null;
      state.list.response = response;
      state.list.status = 'error';
    },
    setListLoading(state) {
      state.list.data = null;
      state.list.response = null;
      state.list.status = 'loading';
    },
    setListSuccess(state, response) {
      state.list.data = response?.data || null;
      state.list.response = response;
      state.list.status = 'success';
    },
    setListFilters(state, request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
    },
  },
  actions: {
    async getPurchaseOutboxQueue({ commit }, request) {
      commit('setListLoading');
      commit('setListFilters', request);
      try {
        const response = await integrationsAlierSGAPurchaseOutboxQueueAdminService.getPurchaseOutboxQueue(request.filters, request.pagination);
        commit('setListSuccess', response);
      } catch (error) {
        commit('setListError', error);
        throw error;
      }
    },
  }
}
